module.exports = __webpack_public_path__ + "img/IMG_3752.a16d8ecc.png";